import React, { Fragment, useEffect, useMemo, useState } from 'react';
import MatchItem from './MatchItem';
import EmptyTableIcon from 'assets/icons/EmptyTableIcon';
import LoadingSpinner from 'components/Commons/LoadingSpinner';
import { GameResponseModel } from 'models';
import { checkMoreSportActive, checkPlayerPropsActive } from 'utils/commonUtils';
import FutureTabContent from './FutureTabContent';
import { useAppSelector } from 'app/hooks';
import { selectShowChatMobile } from 'redux/chatSlice';
import { AiFillCaretUp } from 'react-icons/ai';
import { AiFillCaretDown } from 'react-icons/ai';
import { GroupedLeague, groupedTennisLeague, groupedWomanBasketball } from 'api/mockSportCategory';

interface MatchListProps {
  filteredGames: GameResponseModel[] | undefined;
  category: string;
  tab?: string | null;
}

const MatchList: React.FunctionComponent<MatchListProps> = ({
  category,
  filteredGames,
  tab = null,
}) => {
  const selectedShowChatMobile = useAppSelector(selectShowChatMobile);
  const isMoreSportsActive: boolean = useMemo(() => {
    return checkMoreSportActive(category);
  }, [category]);
  const [openLeagueIds, setOpenLeagueIds] = useState<Record<number, boolean>>({});

  const isPlayerPropsActive: boolean = useMemo(() => {
    return checkPlayerPropsActive(category);
  }, [category]);

  const toggleOpen = (leagueId: number) => {
    setOpenLeagueIds((prev) => ({
      ...prev,
      [leagueId]: !prev[leagueId],
    }));
  };

  const isTennis = category === 'tennis';

  const groupedLeagueTab = (groupSport: GroupedLeague[]) => {
    if (filteredGames && filteredGames.length === 0) {
      return (
        <div className="match-list__body__empty">
          <EmptyTableIcon />
        </div>
      );
    } else {
      return groupSport.map(
        (group) =>
          group.tab === tab &&
          group.leagues.map((item) => {
            const matchingGames =
              filteredGames?.filter((game) => game.sport.title === item.sportTitle) || [];

            if (matchingGames.length === 0) return null;

            return (
              <div key={item.id}>
                <div className="header" onClick={() => toggleOpen(item.id)}>
                  <span className="title">{item.sportTitle}</span>
                  <div className="header__right">
                    <button type="button">
                      {openLeagueIds[item.id] ? <AiFillCaretUp /> : <AiFillCaretDown />}
                    </button>
                  </div>
                </div>
                {openLeagueIds[item.id] && (
                  <div>
                    {matchingGames.map((game) => (
                      <MatchItem
                        key={game.id}
                        category={category}
                        game={game}
                        isMoreSportsActive={isMoreSportsActive}
                        isPlayerPropsActive={isPlayerPropsActive}
                        tab={tab}
                      />
                    ))}
                  </div>
                )}
              </div>
            );
          }),
      );
    }
  };

  useEffect(() => {
    setOpenLeagueIds({});
  }, [tab]);

  return (
    <div className="match-list">
      {tab !== 'Futures' ? (
        <Fragment>
          {filteredGames ? (
            <div
              className={`match-list__body ${
                selectedShowChatMobile ? 'prevent-scroll' : ''
              } non-search_layout`}
            >
              {isTennis ? (
                groupedLeagueTab(groupedTennisLeague)
              ) : category === 'basketball' && tab === 'WNBA' ? (
                groupedLeagueTab(groupedWomanBasketball)
              ) : filteredGames.length ? (
                <Fragment>
                  {filteredGames.map((game) => (
                    <MatchItem
                      key={game.id}
                      category={category}
                      game={game}
                      isMoreSportsActive={isMoreSportsActive}
                      isPlayerPropsActive={isPlayerPropsActive}
                      tab={tab}
                    />
                  ))}
                </Fragment>
              ) : (
                <div className="match-list__body__empty">
                  <EmptyTableIcon />
                </div>
              )}
            </div>
          ) : (
            <div className="match-list__body">
              <LoadingSpinner className="match-list__body__loading" />
            </div>
          )}
        </Fragment>
      ) : (
        <FutureTabContent />
      )}
    </div>
  );
};

export default MatchList;
